import { api } from './api';

export const invoiceApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getInvoice: builder.mutation({
      query: ({
        invoiceNumber,
      }) => {
        const url = 'getInvoice';
        return {
          url,
          method: 'POST',
          body: {
            invoiceNumber,
          },
        };
      },
    }),

    getInvoices: builder.query({
      query: ({
        order,
        orderBy,
        filter,
        filterKey,
        headerFilters,
        pageIndex,
        pageSize,
        dateRange,
      }) => {
        const url = 'getInvoices';
        return {
          url,
          method: 'POST',
          body: {
            order,
            orderBy,
            filter,
            filterKey,
            headerFilters,
            page: pageIndex,
            pageSize,
            dateRange,
          },
        };
      },
    }),
  }),
});

export const {
  useGetInvoicesQuery,
  useGetInvoiceMutation,
} = invoiceApi;
